import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AccountFrame } from '@/components/AccountFrame/AccountFrame';
import { ResponsiveDialog } from '@/components/ResponsiveDialog/ResponsiveDialog';
export type LoginWrapperProps = {
  subDomain: string;
  sprdAccountsContext: string;
};
type LoginDialogProps = LoginWrapperProps & {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onLoginSuccess: () => void;
};
export const LoginDialog = t0 => {
  const $ = _c(16);
  const {
    open,
    subDomain,
    sprdAccountsContext,
    onOpenChange,
    onLoginSuccess
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== t) {
    t1 = t("userMenu.login");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="sr-only">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("general.close");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onLoginSuccess || $[7] !== sprdAccountsContext || $[8] !== subDomain) {
    t4 = <AccountFrame openType="login" subDomain={subDomain} context={sprdAccountsContext} onLoginSuccess={onLoginSuccess} />;
    $[6] = onLoginSuccess;
    $[7] = sprdAccountsContext;
    $[8] = subDomain;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== onOpenChange || $[11] !== open || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <ResponsiveDialog open={open} className="md:max-w-1/2" dismissible={true} title={t2} closeLabel={t3} onOpenChange={onOpenChange}>{t4}</ResponsiveDialog>;
    $[10] = onOpenChange;
    $[11] = open;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};